import { METRIC_COLORS } from './constants';
import { AxisType } from './metricSlider';
export var selectAxisType = function (min) {
  return min >= 0 ? AxisType.POSITIVE_AXIS : AxisType.REAL_AXIS;
};
export var selectValuesFromVariance = function (ranges, axisType) {
  if (axisType === AxisType.POSITIVE_AXIS) {
    return [ranges.acceptable.max, ranges.caution.max];
  } else {
    return [ranges.caution.min, ranges.acceptable.min, ranges.acceptable.max, ranges.caution.max];
  }
};
export function selectVarianceFromValues(values, outsideMin, outsideMax, axisType) {
  if (axisType === AxisType.POSITIVE_AXIS) {
    var acceptableMax_1 = values[0],
      cautionMax_1 = values[1];
    return {
      acceptable: {
        min: 0,
        max: acceptableMax_1
      },
      caution: {
        min: 0,
        max: cautionMax_1
      },
      outside: {
        min: outsideMin,
        max: outsideMax
      }
    };
  }
  var cautionMin = values[0],
    acceptableMin = values[1],
    acceptableMax = values[2],
    cautionMax = values[3];
  return {
    acceptable: {
      min: acceptableMin,
      max: acceptableMax
    },
    caution: {
      min: cautionMin,
      max: cautionMax
    },
    outside: {
      min: outsideMin,
      max: outsideMax
    }
  };
}
export var selectSliderInfo = function (ranges) {
  var axisType = selectAxisType(ranges.outside.min);
  return {
    axisType: axisType,
    min: ranges.outside.min,
    max: ranges.outside.max,
    initialValues: selectValuesFromVariance(ranges, axisType)
  };
};
/**
 * Validates if slider change is allowed
 */
export var selectIsValidSliderChange = function (values, activeThumb, axisType) {
  // Prevent crossing thumbs
  var hasInvalidOrder = activeThumb > 0 && values[activeThumb] <= values[activeThumb - 1] || activeThumb < values.length - 1 && values[activeThumb] >= values[activeThumb + 1];
  if (hasInvalidOrder) return false;
  // Prevent crossing zero on real number axis (bidirectional mode)
  if (axisType === AxisType.REAL_AXIS) {
    var isAcceptableMinThumb = activeThumb === 1;
    var isAcceptableMaxThumb = activeThumb === 2;
    var crossesZeroFromLeft = isAcceptableMinThumb && values[activeThumb] >= 0;
    var crossesZeroFromRight = isAcceptableMaxThumb && values[activeThumb] <= 0;
    if (crossesZeroFromLeft || crossesZeroFromRight) return false;
  } else {
    var isAcceptableMaxThumb = activeThumb === 0;
    var crossesZero = isAcceptableMaxThumb && values[activeThumb] <= 0;
    if (crossesZero) return false;
  }
  return true;
};
/**
 * Calculates segment colors and positions for the track
 */
export var selectTrackSegments = function (values, min, max, axisType) {
  if (axisType === AxisType.POSITIVE_AXIS) {
    var acceptableMax_2 = values[0],
      cautionMax_2 = values[1];
    return [{
      start: min,
      end: acceptableMax_2,
      color: METRIC_COLORS.ACCEPTABLE
    }, {
      start: acceptableMax_2,
      end: cautionMax_2,
      color: METRIC_COLORS.CAUTION
    }, {
      start: cautionMax_2,
      end: max,
      color: METRIC_COLORS.OUTSIDE
    }];
  }
  var cautionMin = values[0],
    acceptableMin = values[1],
    acceptableMax = values[2],
    cautionMax = values[3];
  return [{
    start: min,
    end: cautionMin,
    color: METRIC_COLORS.OUTSIDE
  }, {
    start: cautionMin,
    end: acceptableMin,
    color: METRIC_COLORS.CAUTION
  }, {
    start: acceptableMin,
    end: acceptableMax,
    color: METRIC_COLORS.ACCEPTABLE
  }, {
    start: acceptableMax,
    end: cautionMax,
    color: METRIC_COLORS.CAUTION
  }, {
    start: cautionMax,
    end: max,
    color: METRIC_COLORS.OUTSIDE
  }];
};